<app-auth-layout>
    @if (!mostrarListaEmpresa || !usuarioLoginResponse.listaEmpresa) {
    <!-- Etapa 1: credenciais -->
    <div class="auth-stack">
        <div class="auth-heading">
            <h1>Que bom ter você de volta</h1>
            <p>Informe seus dados para acessar o ATS Workspace</p>
        </div>

        <form class="auth-form" [formGroup]="model" (ngSubmit)="signIn()">
            <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <mat-icon matPrefix class="material-symbols-outlined auth-prefix-icon">mail</mat-icon>
                <input matInput formControlName="email" type="email" autocomplete="username"
                    placeholder="seu@email.com.br">
                @if (model.get('email')?.invalid) {
                <mat-error>Informe o seu e-mail cadastrado</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Senha</mat-label>
                <mat-icon matPrefix class="material-symbols-outlined auth-prefix-icon">lock</mat-icon>
                <input matInput [type]="hide() ? 'password' : 'text'" formControlName="senha"
                    autocomplete="current-password" placeholder="Sua senha">
                <button type="button" mat-icon-button matSuffix (click)="clickEvent($event)"
                    [attr.aria-label]="hide() ? 'Mostrar senha' : 'Ocultar senha'" [attr.aria-pressed]="!hide()">
                    <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
                </button>
                @if (model.get('senha')?.invalid) {
                <mat-error>Informe a sua senha</mat-error>
                }
            </mat-form-field>

            <div class="auth-form-acoes">
                <button type="button" class="auth-link" (click)="redirectRevoceryPassword()">Esqueceu a senha?</button>
            </div>

            <button type="submit" mat-flat-button class="btn-primary auth-btn">
                @if (isLoading) {
                <mat-spinner [diameter]="24"></mat-spinner>
                }
                @else {
                <span>Entrar</span>
                }
                @if (!isLoading) {
                <mat-icon iconPositionEnd class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
                }
            </button>
        </form>

        <div class="auth-info-box">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">verified_user</mat-icon>
            <span>Conexão segura. Nunca pedimos sua senha por email ou WhatsApp.</span>
        </div>

        <p class="auth-rodape-texto">Ainda não é cliente? <a href="#">Conheça o ATS Workspace</a></p>
    </div>
    }
    @else if (isLoading) {
    <!-- Etapa 2 (carregando): entrando na empresa escolhida -->
    <div class="auth-stack auth-center entrando">
        <span class="auth-icon-badge auth-icon-badge--loading" aria-hidden="true">
            <mat-spinner [diameter]="36"></mat-spinner>
        </span>
        <div class="auth-heading">
            <h1>Preparando o seu ambiente</h1>
            @if (nomeEmpresaSelecionada) {
            <p>Abrindo <strong>{{ nomeEmpresaSelecionada }}</strong></p>
            }
        </div>
    </div>
    }
    @else {
    <!-- Etapa 2: escolha da empresa -->
    <div class="auth-stack auth-stack--compacto">
        <button type="button" class="auth-chip-back" (click)="voltarParaLogin()" aria-label="Voltar para o login">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">chevron_left</mat-icon>
            <span>{{ model.get('email')?.value }}</span>
        </button>

        <div class="auth-heading">
            <h1>{{ saudacao }} Em qual empresa vamos trabalhar?</h1>
            <p>
                Você tem acesso a {{ usuarioLoginResponse.listaEmpresa.length }}
                {{ usuarioLoginResponse.listaEmpresa.length === 1 ? 'empresa' : 'empresas' }}.
                Dá para trocar a qualquer momento pelo menu do usuário
            </p>
        </div>

        <div class="empresa-busca">
            <mat-icon class="material-symbols-outlined" aria-hidden="true">search</mat-icon>
            <input type="search" aria-label="Buscar empresa" placeholder="Buscar por nome ou CNPJ"
                [value]="filtroEmpresa()" (input)="filtroEmpresa.set($any($event.target).value)">
        </div>

        <div class="empresa-lista">
            @for (grupo of gruposEmpresa; track grupo.nome) {
            <div class="empresa-grupo">
                <span class="empresa-grupo__titulo">
                    <mat-icon class="material-symbols-outlined" aria-hidden="true">{{ grupo.icone }}</mat-icon>
                    {{ grupo.nome }}
                </span>
                @for (empresa of grupo.empresas; track empresa.idEmpresa) {
                <button type="button" class="empresa-card"
                    [class.empresa-card--selecionada]="empresa.idEmpresa === idEmpresaSelecionada"
                    [attr.aria-pressed]="empresa.idEmpresa === idEmpresaSelecionada"
                    (click)="selecionarEmpresa(empresa)">
                    <span class="empresa-card__avatar" aria-hidden="true">{{ iniciais(empresa.nomeEmpresa) }}</span>
                    <span class="empresa-card__texto">
                        <span class="empresa-card__linha">
                            <strong>{{ empresa.nomeEmpresa }}</strong>
                            @if (empresa.isMatriz) {
                            <span class="empresa-badge">Matriz</span>
                            }
                        </span>
                        <span class="empresa-card__cnpj">CNPJ {{ empresa.cnpj | cpfCnpj }}</span>
                    </span>
                    <mat-icon class="material-symbols-outlined empresa-card__radio" aria-hidden="true">
                        {{ empresa.idEmpresa === idEmpresaSelecionada ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    </mat-icon>
                </button>
                }
            </div>
            }
            @empty {
            <div class="empresa-vazio">
                <strong>Nenhuma empresa encontrada</strong>
                <span>Tente buscar por outro nome ou CNPJ</span>
            </div>
            }
        </div>

        <button type="button" mat-flat-button class="btn-primary auth-btn" [disabled]="!idEmpresaSelecionada"
            (click)="signIn()">
            @if (idEmpresaSelecionada) {
            <span>Entrar na empresa</span>
            }
            @else {
            <span>Selecione uma empresa</span>
            }
            @if (idEmpresaSelecionada) {
            <mat-icon iconPositionEnd class="material-symbols-outlined" aria-hidden="true">arrow_forward</mat-icon>
            }
        </button>
    </div>
    }
</app-auth-layout>
